import React from 'react';
import ReactDOM from 'react-dom';
import { Box, Inscription } from '@common-fe/common-fe';

import { Modal } from '@/components';
import { ThemeWrapper } from '@/modules/core/components';

interface Props {
  description?: React.ReactNode;
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  isHoveringSensitive?: boolean;
  title?: string;
  children: React.ReactNode;
  testId?: string;
  maxWidth?: string;
  contentStyle?: React.CSSProperties;
  wrapperStyle?: React.CSSProperties;
  titleBoxStyle?: React.CSSProperties;
  isClosingByClickOutsideBlocked?: boolean;
}
const node = document.createElement('div');
document.body.appendChild(node);
const ModalWrapper: React.FC<Props> = ({
  description,
  title,
  children,
  onSetVisible,
  isHoveringSensitive,
  testId,
  visible,
  maxWidth,
  contentStyle,
  wrapperStyle,
  isClosingByClickOutsideBlocked,
  titleBoxStyle,
}) => ReactDOM.createPortal(
  <ThemeWrapper>
    <Modal
      isHoveringSensitive={isHoveringSensitive}
      testId={testId}
      visible={visible}
      onSetVisible={onSetVisible}
      maxWidth={maxWidth}
      contentStyle={contentStyle}
      wrapperStyle={wrapperStyle}
      isClosingByClickOutsideBlocked={isClosingByClickOutsideBlocked}
    >
      <Box direction="column">
        {title && (
          <Box
            align="center"
            justify="center"
            pad={{ bottom: 'spacing24' }}
            style={titleBoxStyle}
          >
            <Inscription
              size="2xl"
              color="textTitle"
              weight="bold"
              lineHeight='32px'
              style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              {title}
            </Inscription>
            {description}
          </Box>
        )}
        <Box>
          {children}
        </Box>
      </Box>
    </Modal>
  </ThemeWrapper>,
  node,
);

export default ModalWrapper;
